<template>
  <div class="tabs_content" v-show="$_loggedUser_action_allowed('devices')">
    <section>
      <a
          class="tab_button tab_button_refresh title_tooltip"
          :data-title="'Obnovit' | translate"
          @click.stop.prevent="getEntities(); getPairingCodes()"
          v-translate>
      </a>
      <div class="status">
        <h2 v-translate>Párovací kódy</h2>
        <h2>&nbsp;({{ Object.keys(pairingCodes).length }})</h2>
        <a v-if="isEditable"
           :title="'Přidat párovací kód' | translate"
           :class="['add', 'add_expand', { open: newPairingCodeOpen }, { btn_inactive: !isAllowedToAddDeviceOrPairingCode}]"
           @click.prevent="toggleNewPairingCodes()"
           v-translate>Přidat párovací kód
        </a>
      </div>
      <div :class="['filter', 'expand_content', { open: newPairingCodeOpen }]">
        <div class="field_left">
          <select-box
              id="deviceselect"
              :options="pairingCodeDeviceOptions"
              v-model="pairingCodeDeviceId"
              ref="deviceselectref"
          >
            <translate class="translate">Zařízení</translate>
          </select-box>
        </div>
        <div class="field_right">
          <date-picker
              id="active-to-add"
              attrKey="expiration_date"
              date-format="d. m. yy"
              v-model="newPairingCode.expiration_date"
              @update-date="updateNewPairingCodeDate"
          >
            <translate class="translate">Platnost pro zadání kódu</translate>
          </date-picker>
        </div>
        <div class="field_left">
          <text-input
              id="device-name-add-2"
              v-model="newPairingCode.name"
              :required="true"
              ref="newpairingcodename"
              :disabled="pairingCodeDeviceId !== null"
          >
            <translate class="translate">Název zařízení</translate>
          </text-input>
        </div>
        <div class="field_right">
          <checkbox-input
              id="service-code-add"
              v-model="newPairingCode.service_code"
              ref="newpairingcodeservicecode"
              v-if="$_loggedUser_action_allowed('serviceDevices', 'create')"
          >
            <translate class="translate">Servisní</translate>
          </checkbox-input>
        </div>
        <div class="field_left"><div class="field"></div></div>
        <div class="field_right">
          <div class="field">
            <input
                type="submit"
                class="btn"
                :value="'Uložit' | translate"
                @click.prevent.stop="addPairingCode"
            />
          </div>
        </div>
      </div>
      <div>
        <table class="vypis vypis_detail parovaci_kody">
          <not-sorting-table-header
              v-if="Object.keys(pairingCodes).length > 0"
              :titles="pairingCodeTableTitles"
          ></not-sorting-table-header>
          <tbody>
          <pairing-code-row
              v-for="pairingCode in pairingCodes"
              :pairingCode="pairingCode"
              :key="pairingCode.id"
              @delete-pairing-code="deletePairingCode"
          />
          <tr v-if="Object.keys(pairingCodes).length === 0">
               <td colspan="8" v-translate>Nebyly nalezeny žádné párovací kódy.</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="status">
      <h2 v-translate>Všechna zařízení</h2>
      <h2>&nbsp;({{ totalCount }})</h2>
        <a v-if="isEditable"
           :title="'Přidat zařízení' | translate"
           :class="['add', 'add_expand', { open: newDeviceOpen }, { btn_inactive: !isAllowedToAddDeviceOrPairingCode}]"
           @click.prevent="toggleNewDevices()"
           v-translate>Přidat zařízení
        </a>
      </div>
      <div :class="['filter', 'expand_content', { open: newDeviceOpen }]">
        <div class="field_left">
          <text-input
              id="device-name-add-1"
              v-model="newDevice.name"
              :required="true"
              ref="newdevicenameref"
          >
            <translate class="translate">Název zařízení</translate>
          </text-input>
        </div>
        <div class="field_right">
          <text-input
              id="mac-address-add"
              v-model="newDevice.mac_address"
              :required="true"
              ref="newdevicemacaddressref"
          >
            <translate class="translate">MAC adresa</translate>
          </text-input>
          <checkbox-input
              id="service-device-add"
              v-model="newDevice.service_device"
              ref="newdeviceservicedevice"
              v-if="$_loggedUser_action_allowed('serviceDevices', 'create')"
          >
            <translate class="translate">Servisní</translate>
          </checkbox-input>
        </div>
        <div class="field_left">
          <div class="field"></div>
        </div>
        <div class="field_right">
          <div class="field">
            <input
                type="submit"
                class="btn"
                :value="'Uložit' | translate"
                @click.prevent.stop="addDevice"
            />
          </div>
        </div>
      </div>

      <div class="filter">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search" />
        </div>
      </div>

      <form>
        <div class="scroll-wrapper">
      <div class="table_overflow" id="contentBox" data-table-id="subscribers-devices">
            <table class="vypis">
              <tr  v-if="entities.length > 0">
                <th class="no_padding drag_drop"></th>
                <th class="no_padding checkbox"></th>
                <sorting-table-title
                    v-for="title in pairedDeviceTableTitles"
                    :key="title.id"
                    :column="title.column"
                    :sort="getActiveSort(title.column)"
                    @changeSorting="changeSorting"
                >{{ title.name }}
                </sorting-table-title>
                <th class="no_padding edit"></th>
              </tr>
              <paired-device-row
                  v-for="device in entities"
                  :device="device"
                  :key="device.id"
                  :device-profiles="deviceProfiles"
                  :selectedEntities="selectedEntities"
                  :isEditable="isEditable"
                  :deviceLogViewerUrl="deviceLogViewerUrl"
                  :showDeviceToken="showDeviceToken"
                  @input="select"
                  @update-device="updateDevice"
                  @delete-device="deleteDevice"
                  :ref="'paired-device-row-ref-' + device.id"
              />
              <tr v-if="entities.length === 0">
                <td colspan="8">{{ $gettext('Nebyla nalezena žádná zařízení.') }}</td>
              </tr>
            </table>
          </div>
        </div>
        <list-action-line
            :entities="entities"
            :selected-entities="selectedEntities"
            :multiple-action-options="multipleActionOptions"
            :offset="formFields.offset"
            :limit="formFields.limit"
            :total-count="totalCount"
            table-id="subscribers-devices"
            @select-all="toggleSelectAll"
            @run-multiple-action="_executeMultipleAction"
            @limit="setLimit"
            @offset="setOffset"
            ref="action_line"
        />
      </form>
    </section>
  </div>
</template>

<script>
import PairedDeviceRow from "@/components/views/subscribers/devices/PairedDeviceRow"
import PairingCodeRow from "@/components/views/subscribers/devices/PairingCodeRow"
import NotSortingTableHeader from "@/components/common/NotSortingTableHeader"
import listActions from "../../../mixins/list-actions";
import detailActions from "@/components/mixins/detail-actions"

export default {
  name: "SubscriberDetailDevices",
  components: {
    NotSortingTableHeader,
    PairedDeviceRow,
    PairingCodeRow
  },
  mixins: [detailActions, listActions],
  data() {
    return {
      deviceProfiles: [],
      newDevice: {},
      newDeviceOpen: false,
      totalCount: 0,

      pairingCodes: [],
      newPairingCode: {
        name: null,
        expiration_date: null,
      },
      newPairingCodeOpen: false,
      isAllowedToAddDeviceOrPairingCode: false,

      requiredDeviceRefs: [
        'newdevicenameref',
        'newdevicemacaddressref',
      ],
      requiredPairingCodeRefs: [
        'newpairingcodename',
      ],
      pairingCodeDeviceId: null,
    }
  },
  props: {
    entity: Object,
    // ??
    errorMessages: {
      type: [Array, Object],
      default: function () {
        return []
      },
    },
  },
  created(SubscriberService, DeviceService, PairingCodeService) {
    this.subscriberService = SubscriberService;
    this.deviceService = DeviceService;
    this.pairingCodeService = PairingCodeService;

    this.getEntities()
    this.getPairingCodes()

    this.subscriberService.getSubscriberDeviceProfiles(this.entity.id).then((data) => {
      this.deviceProfiles = data['device_profiles']
    })
  },
  computed: {
    isEditable() {
      return this.$_loggedUser_operator_item_update_action_allowed(this.entity.id_operator, 'devices')
    },

    pairingCodeDeviceOptions() {
      let result = Object.values(this.entities).map(obj => ({
        id: obj.id,
        text: obj.name
      }));
      result.unshift({ 'id': null, 'text': this.$gettext('Bez zařízení') });
      return result;
    },
    showDeviceToken() {
      return this.$_loggedUser_action_allowed('subscribers', 'read', ['OWN_AND_GLOBAL', 'ALL']);
    },
    pairedDeviceTableTitles() {
      const titles = [
        { id: 1, name: this.$gettext('Název zařízení'), column: 'sName' },
        { id: 2, name: this.$gettext('Přednastavený') },
        this.$_loggedUser_action_allowed('serviceDevices', 'create') && { id: 3, name: this.$gettext('Servisní') },
        { id: 4, name: this.$gettext('MAC adresa'), column: 'sMacAddress' },
        { id: 5, name: this.$gettext('Profil'), column: 'sProfileName' },
        { id: 6, name: this.$gettext('Token') },
        { id: 7, name: this.$gettext('Typ'), column: 'sTypeName' },
        { id: 8, name: this.$gettext('Model') },
        { id: 9, name: this.$gettext('Firmware'), column: 'sFirmware' },
        { id: 10, name: this.$gettext('Aplikace') },
        { id: 11, name: this.$gettext('Poslední start zařízení'), column: 'sLastStart' },
        { id: 12, name: this.$gettext('Vytvořeno'), column: 'sDateCreated' },
      ]

      return titles.filter(t => t)
    },
    pairingCodeTableTitles() {
      const titles = [
        this.$gettext('Název zařízení'),
        this.$_loggedUser_action_allowed('serviceDevices', 'create') && this.$gettext('Servisní'),
        this.$gettext('Párovací kód'),
        this.$gettext('Platné do'),
        this.$gettext('Vytvořeno')
      ]

      return titles.filter(t => t)
    },
    csvHeaders() {
      let headers = {
        'name': { name: this.$gettext('Název zařízení') },
        'pre_provisioned': {
          name: this.$gettext('Přednastavený'), callback: (entity) => {
            return entity.pre_provisioned ? this.$gettext("Ano") : this.$gettext("Ne")
          }
        },
        'service_device': {
          name: this.$gettext('Servisní'), callback: (entity) => {
            return entity.service_device ? this.$gettext("Ano") : this.$gettext("Ne")
          }
        },
        'mac_address': { name: this.$gettext('MAC adresa') },
        'profile': { name: this.$gettext('Profil') },
        'token': {
          name: this.$gettext("Token"), callbalck: (entity) => {
            this.showDeviceToken() ? entity.token : entity.safe_token
          }
        },
        'type': { name: this.$gettext('Typ') },
        'model': { name: this.$gettext('Model') },
        'firmware': { name: this.$gettext('Firmware') },
        'application': { name: this.$gettext('Aplikace') },
      }
      if (this.isEditable) {
        headers.token = { name: this.$gettext('Token') };
      }
      headers.last_start = {
        name: this.$gettext('Poslední start zařízení'), callback: (entity) => {
          return entity.last_start ? this.$_datetime_format(entity.last_start) : ''
        }
      };
      headers.date_created = { name: this.$gettext('Vytvořeno') };

      return headers;
    },
    multipleActionOptions() {
      let options = [
        { value: 'choose', text: this.$gettext('Vyberte akci') },
        { value: 'exportCsv', text: this.$gettext('Exportovat do CSV') }
      ];
      if (this.$_loggedUser_action_allowed('devices', 'update')) {
        options.push({ value: 'softrestart', text: this.$gettext('Soft restart') });
        options.push({ value: 'hardrestart', text: this.$gettext('Hard restart') });
        options.push({ value: 'forcefullreload', text: this.$gettext('Force full reload') });
      }
      if (this.$_loggedUser_action_allowed('devices', 'delete')) {
        options.push({ value: 'delete', text: this.$gettext('Smazat') });
      }

      return options;
    }
  },
  methods: {
    getEntities() {
      const params = { ...this.getFormFields() }
      this.subscriberService.getSubscriberDevices(this.entity.id, params).then((data) => {
        this.entities = data['devices']
        this.totalCount = data['totalCount']
        this.deviceLogViewerUrl = data['device_log_viewer_url']
        this.isAllowedToAddDeviceOrPairingCode = data['is_allowed_to_add_device_or_pairing_code']
      })
    },
    addDevice() {
      let params = this._.pick(this.newDevice, ['name', 'mac_address'])
      params['id_subscriber'] = this.entity.id

      this.deviceService.createEntity(params)
          .then(() => {
            this.getEntities()
          })
          .catch((error) => {
            this.validateRequiredFields(error)
            this.setErrorMessage(this._processDetailErrorMessage(error))
          })
    },
    updateDevice(data) {
      let params = this._.pick(data, ['name', 'id_profile', 'pre_provisioned'])
      params['id_subscriber'] = this.entity.id

      this.deviceService.updateEntity(data['id'], params)
          .then(() => {
            this.getEntities()
            this.closeRows()
          })
          .catch((error) => {
            this.validateRequiredFields(error)
            this.setErrorMessage(this._processDetailErrorMessage(error))
          })
    },
    deleteDevice(id, showPopup = true) {
      if (showPopup) {
        if (this._.includes(id, ',')) {
          this.showPopup(id, 'delete-multi', 'delete-device-multi')
        } else {
          this.showPopup(id, 'delete', 'delete-device')
        }
      } else {
        this.deviceService.deleteDevice(id)
            .then(() => {
              this.setSuccessMessage()
              this.getEntities()
            })
            .catch(function (error) {
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },

    getPairingCodes() {
      this.subscriberService.getSubscriberPairingCodes(this.entity.id).then((data) => {
        this.pairingCodes = data['pairing_codes']
        this.isAllowedToAddDeviceOrPairingCode = data['is_allowed_to_add_device_or_pairing_code']
      })
    },
    addPairingCode() {
      let params = {
        'name': this.newPairingCode['name'],
        'id_subscriber': this.entity.id,
        'id_device': this.newPairingCode['id_device']
      }

      let date = this.$_date_toMysqlFormatFromString(this.newPairingCode['expiration_date'])
      if (date) {
        params['expiration_date'] = date
      }

      this.pairingCodeService.createEntity(params)
          .then(() => {
            this.getPairingCodes()
          })
          .catch((error) => {
            this.validateRequiredFields(error)
            this.setErrorMessage(this._processDetailErrorMessage(error))
          })
    },
    deletePairingCode(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'delete-pairing-code')
      } else {
        this.pairingCodeService.deletePairingCode(id)
            .then(() => {
              this.setSuccessMessage()
              this.getPairingCodes()
            })
            .catch(function (error) {
              this.setErrorMessage(error['error_message'])
            }.bind(this))
      }
    },

    _executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'softrestart':
          this.deviceService.restartDevices(actionIds, "soft").then((data) => {
            this.setSuccessMessage(this.$gettextInterpolate(this.$gettext('K soft restartování označeno %{count} zařízení.'), {
              count: data.count
            }));
          });
          break;
        case 'hardrestart':
          this.deviceService.restartDevices(actionIds, "hard").then((data) => {
            this.setSuccessMessage(this.$gettextInterpolate(this.$gettext('K hard restartování označeno %{count} zařízení.'), {
              count: data.count
            }));
          });
          break;
        case 'forcefullreload':
          this.deviceService.forceFullReloadDevices(actionIds).then((data) => {
            this.setSuccessMessage(this.$gettextInterpolate(this.$gettext('K přenačtení označeno %{count} zařízení.'), {
              count: data.count
            }));
          });
          break;
        default:
          this.executeMultipleAction(action, activeKey);
      }
    },
    _exportCsv() {
      this.setLoadingMessage()
      const params = { ...this.getFormFields() }
      delete params.limit;
      delete params.offset;
      this.subscriberService.getSubscriberDevices(this.entity.id, params).then((data) => {
        this._createExportCsv(this.csvHeaders, data['devices']);
      })
    },
    closeRows() {
      this._.forEach(this.entities, (device) => {
        this.$refs['paired-device-row-ref-' + device.id][0].hideMoreInfo()
      })
    },
    validateRequiredFields(error) {
      if (this.newDeviceOpen) {
        if (!this.newDevice.name) {
          this.$refs['newdevicenameref'].setForcedInvalid(true, this.$gettext('Zadejte název'))
        } else {
          this.resetNewDeviceName()
        }

        if (!this.newDevice.mac_address) {
          this.$refs['newdevicemacaddressref'].setForcedInvalid(true, this.$gettext('Přednastavené zařízení musí mít vyplněnou MAC adresu.'))
        } else if (this.newDevice.mac_address.length < 17) {
          this.$refs['newdevicemacaddressref'].setForcedInvalid(true, this.$gettext('MAC adresa musí obsahovat 17 znaků ve správném formátu'))
        } else {
          this.resetNewDeviceMacAddress()
        }
      }
      if (this.newPairingCodeOpen) {
        if (!this.newPairingCode.name) {
          this.$refs['newpairingcodename'].setForcedInvalid(true, this.$gettext('Zadejte název'))
        } else {
          this.resetNewPairingCode()
        }
      }
    },
    resetNewDevice() {
      this.resetNewDeviceName()
      this.resetNewDeviceMacAddress()
    },
    resetNewDeviceName() {
      this.$refs['newdevicenameref'].setForcedInvalid()
      this.$refs['newdevicenameref'].setTouched(false)
    },
    resetNewDeviceMacAddress() {
      this.$refs['newdevicemacaddressref'].setForcedInvalid()
      this.$refs['newdevicemacaddressref'].setTouched(false)
    },
    resetNewPairingCode() {
      this.$refs['newpairingcodename'].setForcedInvalid()
      this.$refs['newpairingcodename'].setTouched(false)
    },
    toggleNewDevices() {
      this.newDeviceOpen = this.isAllowedToAddDeviceOrPairingCode ? !this.newDeviceOpen : false
    },
    toggleNewPairingCodes() {
      this.pairingCodeDeviceId = null;
      this.newPairingCodeOpen = this.isAllowedToAddDeviceOrPairingCode ? !this.newPairingCodeOpen : false
    },
    updateNewPairingCodeDate(dateInfo) {
      this.newPairingCode[dateInfo.attrKey] = dateInfo.date
    },
    deleteEntity(id, showPopup = true) {
      if (showPopup) {
        if (this._.includes(id, ',')) {
          this.showPopup(id, 'delete-multi', 'delete-device-multi')
        } else {
          this.showPopup(id, 'delete', 'delete-device')
        }
      }
    },
  },
  watch: {
    pairingCodeDeviceId() {
      if (this.pairingCodeDeviceId === null) {
        this.newPairingCode.name = '';
      } else {
        // FIXME devices[...]
        this.newPairingCode.name = this.devices[this.pairingCodeDeviceId].name;
      }
      this.newPairingCode.id_device = this.pairingCodeDeviceId ? Number(this.pairingCodeDeviceId) : null;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/devices/Devices.vue